import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'

// Actions
// import * as DisputeUciActions from '../../modules/DisputeUciActions'
import { doHidePopup } from 'Store/actions/popup'

// Component
import DisputeEntryModal from './DisputeEntryModal'

// Utilities
// import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = (dispatch) => ({
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = (state) => ({
  // TODO: add state mappings
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(DisputeEntryModal)
